export const businessInfo = {
  productName: 'PostBrix',
  legalName: 'PostBrix',
  supportEmail: 'support@postbrix.com',
  billingEmail: 'billing@postbrix.com',
  privacyEmail: 'privacy@postbrix.com',
  legalEmail: 'legal@postbrix.com',
  helloEmail: 'hello@postbrix.com',
  salesEmail: 'sales@postbrix.com',
  partnersEmail: 'partners@postbrix.com',
  securityEmail: 'security@postbrix.com',
  bugsEmail: 'bugs@postbrix.com',
  phone: '' as string,
  address: ['Madhya Pradesh, India'],
  supportHours: 'Monday to Friday, 10:00 AM to 6:00 PM IST',
  supportSla: 'We aim to respond to all inquiries within 24-48 business hours.',
  socials: {
    x: 'https://x.com/postbrix',
    linkedin: 'https://linkedin.com/company/postbrix',
    instagram: 'https://instagram.com/postbrix',
    facebook: 'https://facebook.com/postbrix',
    youtube: 'https://youtube.com/@postbrix',
  },
  updatedAt: 'May 10, 2026',
} as const;
